export default function mountDeferredStyles() {
  const elements = document.querySelectorAll('[data-cwt-defer-href]');
  elements.forEach(function (element) {
    const styleURL = element.getAttribute('data-cwt-defer-href');
    const delayString = element.getAttribute('data-cwt-defer-wait');
    const delay = Number(delayString);

    if (!delay) {
      return;
    }

    setTimeout(function () {
      const styleElement = document.createElement('link');
      styleElement.setAttribute('rel', 'stylesheet');
      styleElement.setAttribute('href', styleURL);
      element.appendChild(styleElement);
    }, delay);
  });
}
